export default __webpack_public_path__ + "assets/images/989b0ac0e7e603f4cc66f1ce3c597e25.svg";